import getLoyaltyAccountClosedErrorCode from 'loyalty/lib/getLoyaltyAccountClosedErrorCode'
import getIsLoyaltyEnabled from './getIsLoyaltyEnabled'

/**
 * Whether the customer has a Société account they can no longer use (closed by an admin or in
 * iLoyal). Such a customer sees the site as a non-member, but must never be invited to join or
 * activate Société: they're still a member, and enrolling again fails.
 */
function getIsLoyaltyAccountClosed(state: App.State): boolean {
  return getIsLoyaltyEnabled(state) && !!getLoyaltyAccountClosedErrorCode(state.loyalty.account.error)
}

export default getIsLoyaltyAccountClosed
